import { getCoursesApiUrl } from "js/utils/getBackendUrl";
import * as clsApi from "./classroomApi";

export type EnabledFeaturesResponse = {
	features: {
		name: string;
		enabled: boolean;
	}[];
};

export async function getEnabledFeatures(): Promise<Response> {
	const username = clsApi.authHeaders().User;
	const appliance = clsApi.authHeaders().Device;
	const token = clsApi.authHeaders().Authorization;
	const coursesApiUrl = getCoursesApiUrl(window.location.hostname);
	return fetch(`${coursesApiUrl}/v1/teachers/${username}/enabledFeatures`, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
			Authorization: token,
			Device: appliance,
		},
	});
}
